import angular from 'angular'

import ngRedux from 'ng-redux'
import { SaleManager } from '../../managers/sale-manager'
import { TrainingModeManager } from '../../managers/training-mode-manager'
import { DebounceOptions } from '../../constants'
import { selectSaleReturnFor } from '../../state/selectors'
import { CustomerBalancesManager } from '../../managers/customer-balances-manager'
import { CustomerSuggestions } from '../../components/customer/customer-suggestions.service'

/**
 * ===============================
 * ADD CUSTOMER TO SALE CONTROLLER
 * ===============================
 */
export class AddCustomerToSaleCtrl {
  public cancelButtonLabel: $TSFixMe
  public customer: $TSFixMe
  public customerBalances: $TSFixMe
  public customerErrorTemplate: $TSFixMe
  public customerGroups: $TSFixMe
  public customerSource: $TSFixMe
  public isTrainingModeEnabled: boolean | undefined
  public title: string
  public debounceOptions: DebounceOptions | undefined

  constructor(
    public close: $TSFixMe,
    private options: $TSFixMe,
    private customerModals: $TSFixMe,
    private saleManager: SaleManager,
    private trainingModeManager: TrainingModeManager,
    private customerBalancesManager: CustomerBalancesManager,
    private customerSuggestions: CustomerSuggestions,
    private $ngRedux: ngRedux.INgRedux
  ) {
    'ngInject'
    if (this.trainingModeManager.trainingModeEnabled) {
      this.customerSource = this.customerSuggestions.getSource({
        readOnly: true,
      })
    } else {
      this.customerSource = this.customerSuggestions.getSource({
        create: ({ query }) => {
          const promiseForNewCustomer = this.customerModals
            .createCustomer({ query })
            .then((customer: $TSFixMe) =>
              this.saleManager.addCustomer(customer)
            )
            // Modal closed without saving. Nothing to do.
            .catch(angular.noop)
          this.close(promiseForNewCustomer)
        },
      })
    }

    // Replaces the default error message for the "add customer to sale" autocomplete
    this.customerErrorTemplate = this.customerSuggestions.customerErrorTemplate
    this.customerGroups = this.options.customerGroups
    const saleIsReturn = Boolean(selectSaleReturnFor(this.$ngRedux.getState()))
    this.title = `Add a customer to the ${saleIsReturn ? 'return ' : ''}sale`
    this.cancelButtonLabel = this.options.cancelButtonLabel || 'Cancel'
    this.isTrainingModeEnabled = this.trainingModeManager.trainingModeEnabled
    this.debounceOptions = this.saleManager.debounceOptions
  }

  /**
   * Handles a result being selected by the search for a customer and sets the appropriate object on
   * the model. Ensure's that we have the most up-to-date information for the customer if the register is online
   *
   * @method onSelectResult
   */
  public onSelectResult(customerResult: $TSFixMe) {
    this.customerBalancesManager
      .getCustomerBalances(customerResult.customer)
      .then(customerBalances => {
        this.customerBalances = customerBalances
      })
    this.customer = customerResult.customer
  }

  /**
   * Handles the "add new customer" button being clicked, which triggers the quick add customer lightbox and closes the
   * current lightbox
   *
   * @method addNewCustomer
   */
  public addNewCustomer() {
    const promiseForNewCustomer = this.customerModals
      .createCustomer()
      .then((customer: $TSFixMe) => this.saleManager.addCustomer(customer))
    this.close(promiseForNewCustomer)
  }

  /**
   * Handles the modal being submitted, persisting the selected customer to the Sale and closes the modal
   *
   * @method addCustomerToSale
   */
  public addCustomerToSale() {
    this.saleManager.addCustomer(this.customer).then(() => this.close())
  }
}

/**
 * Controller for the lightbox used for adding a Customer to a sale
 *
 * @module webregister.controllers.AddCustomerToSaleCtrl
 */
angular
  .module('webregister.controllers')
  .controller('AddCustomerToSaleCtrl', AddCustomerToSaleCtrl)
